import { render, staticRenderFns } from "./HomePageFR.vue?vue&type=template&id=484cd429&scoped=true"
import script from "./HomePageFR.vue?vue&type=script&lang=js"
export * from "./HomePageFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484cd429",
  null
  
)

export default component.exports